import { Platform } from 'react-native';

import { useFeatureFlag } from '@order/LaunchDarkly';
import { useTelemetry } from '@order/Telemetry';

// ─────────────────────────────────────────────────────────────────────────────

export const usePermissionsPrimerExperiment = () => {
  const variant = useFeatureFlag('CELS-5256-geofencing-primer-variant');

  const { track } = useTelemetry();

  // ─── Flags ───────────────────────────────────────────────────────────

  const isEnabled = Platform.OS !== 'web' && variant !== 'disabled';

  // ─── Handlers ────────────────────────────────────────────────────────

  const trackExperimentStarted = () => {
    if (!isEnabled) return;

    track('$experiment_started', {
      'Experiment name': PRIMER_EXPERIMENT_ID,
      'Variant name': variant,
    });
  };

  // ─────────────────────────────────────────────────────────────────────

  return { variant, isEnabled, trackExperimentStarted };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const PRIMER_EXPERIMENT_ID = 'permission_primer_placement' as const;
